<template>
    <span class="print-view">
        <div class="btn-group text-center my-4" v-if="!is_full_screen">
            <vs-button class="mx-1 my-1" type="filled" @click="onClickPrint()">Print & Download</vs-button>
        </div>
        <page id="printDiv" size="A4">

            <body id="myelement">
                <div id="full-wrap">


                    <main class="clearfix">

                        <div id="user" class="clearfix">

                            <div id="user-top">

                                <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                                    <tbody>
                                        <tr>
                                            <td class="head align-left">
                                                <img id="logo"
                                                    src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                                                    alt="Logo" width="300" height="150" />
                                            </td>


                                        </tr>


                                        <tr>
                                            <td>
                                                <table id="main-tbl">
                                                    <thead class="">
                                                        <tr>
                                                            <td colspan="2" class="head">
                                                                <h4 style="color: black" class="m-0"><b>DELIVERY NOTE</b>
                                                                </h4>
                                                            </td>
                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                        <tr>

                                                            <td class="toptd bd-b-0 bd-r-0">
                                                                <table id="in-tbl">
                                                                    <thead>
                                                                        <tr>
                                                                            <td colspan="2" class="headtd">
                                                                                <div>
                                                                                    <p class="sml">SHIPPER/EXPORTER</p>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td class="bodytda">
                                                                                <div>
                                                                                    <p class="sml">
                                                                                        {{
                                                                                            invoice_data.shipper_address.company_name
                                                                                        }}<br>
                                                                                        {{
                                                                                            invoice_data.shipper_address.line_1
                                                                                        }}<br>
                                                                                        {{
                                                                                            invoice_data.shipper_address.line_2
                                                                                        }}<br>
                                                                                        {{
                                                                                            invoice_data.shipper_address.town_state
                                                                                        }}<br>
                                                                                        {{
                                                                                            invoice_data.shipper_address.post_code
                                                                                        }}<br>
                                                                                        {{
                                                                                            invoice_data.shipper_address.country
                                                                                        }}</p>
                                                                                </div>
                                                                            </td>
                                                                            <td class="bodytdb">
                                                                                <div>
                                                                                    <p class="sml">Tel. {{ invoice_data.tel
                                                                                        || '' }}<br>
                                                                                        Email: {{ invoice_data.email || ''
                                                                                        }}<br>
                                                                                        VAT Reg No: {{ invoice_data.vat_reg
                                                                                            || '' }}<br>
                                                                                        Company No: {{
                                                                                            invoice_data.company_no || '' }}<br>
                                                                                        EORI for NL: {{ invoice_data.eori_ni
                                                                                            || '' }}<br>
                                                                                        EORI for EU: {{ invoice_data.eori_eu
                                                                                            || '' }}</p>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                            <td class="toptd bd-b-0 bd-l-0">
                                                                <table id="in-tbl">
                                                                    <tr>
                                                                        <td>
                                                                            <div>
                                                                                <p class="sml">DATE:</p>
                                                                                <p class="sml"><b>{{ invoice_data.note_date
                                                                                    || '' }}</b></p><br>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div>
                                                                                <p class="sml">DELIVERY NOTE NO:</p>
                                                                                <p class="sml"><b>{{
                                                                                    invoice_data.note_number || ''
                                                                                }}</b></p>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            <div>
                                                                                <p class="sml">DELIVERY DUE DATE:</p>
                                                                                <p class="sml"><b>{{
                                                                                    invoice_data.note_due_date || ''
                                                                                }}</b></p><br>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div>
                                                                                <p class="sml">ITS ORDER NUMBER:</p>
                                                                                <p class="sml">
                                                                                    <span
                                                                                        v-for="(order, index_its_code) in invoice_data.order_code"
                                                                                        :key="index_its_code">
                                                                                        <b>{{ order + ', ' }}</b>
                                                                                    </span>
                                                                                </p>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr>

                                                            <td class="toptd bd-b-0 bd-r-0">
                                                                <table id="in-tbl">
                                                                    <thead>
                                                                        <tr>
                                                                            <td colspan="2" class="headtd">
                                                                                <div>
                                                                                    <p class="sml">CONSIGNEE/RECEIVER</p>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td class="bodytda">
                                                                                <div>
                                                                                    <p class="sml">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.customer_address.company_name
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.customer_address.company_name">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.customer_address.line_1
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.customer_address.line_1">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.customer_address.line_2
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.customer_address.line_2">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.customer_address.line_3
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.customer_address.line_3">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.customer_address.town_state
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.customer_address.town_state">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.customer_address.post_code
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.customer_address.post_code">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.customer_address.country
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.customer_address.country">
                                                                                    </p>
                                                                                </div>
                                                                            </td>
                                                                            <td class="bodytdb">
                                                                                <div>
                                                                                    <p class="sml">
                                                                                        VAT: {{ invoice_data.consignee_vat
                                                                                            || 'N/A' }}<br>
                                                                                        EORI: {{ invoice_data.consignee_eori
                                                                                            || 'N/A' }}<br>
                                                                                        TSS Reg No: {{
                                                                                            invoice_data.consignee_tss_registration_number
                                                                                            || 'N/A' }}<br>
                                                                                        TEL: {{ invoice_data.consignee_tel
                                                                                            || '' }}<br>
                                                                                        IMPORT LICENCE NO: {{
                                                                                            invoice_data.import_licence_no ||
                                                                                            'N/A' }}</p>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                            <td class="toptd bd-b-0 bd-l-0">
                                                                <table id="in-tbl">
                                                                    <tr>
                                                                        <td>
                                                                            <div>
                                                                                <p class="sml">CUSTOMER ACCOUNT NUMBER:</p>
                                                                                <p class="sml"><b>{{
                                                                                    invoice_data.customer_account_number
                                                                                    || '' }}</b></p><br>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div>
                                                                                <p class="sml">TRANSPORT AWB/REF NUMBER:</p>
                                                                                <p class="sml"><b>{{
                                                                                    invoice_data.transport_ref_number
                                                                                }}</b></p>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            <div>
                                                                                <p class="sml">CUSTOMER P.O. NUMBER:</p>
                                                                                <p class="sml">
                                                                                    <span
                                                                                        v-for="(order, index_order) in invoice_data.customer_order_number"
                                                                                        :key="index_order">
                                                                                        <b>{{ order + ', ' }}</b>
                                                                                    </span>
                                                                                </p><br>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div>
                                                                                <p class="sml">INCOTERMS:</p>
                                                                                <p class="sml"><b>{{ invoice_data.incoterm
                                                                                }}</b></p>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr>

                                                            <td class="toptd bd-r-0">
                                                                <table id="in-tbl">
                                                                    <thead>
                                                                        <tr>
                                                                            <td colspan="2" class="headtd">
                                                                                <div>
                                                                                    <p class="sml">DELIVERY SITE</p>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td class="bodytd">
                                                                                <div>
                                                                                    <p class="sml">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.delivery_address.company_name
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.delivery_address.company_name">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.delivery_address.line_1
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.delivery_address.line_1">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.delivery_address.line_2
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.delivery_address.line_2">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.delivery_address.line_3
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.delivery_address.line_3">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.delivery_address.town_state
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.delivery_address.town_state">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.delivery_address.post_code
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.delivery_address.post_code">
                                                                                        <span style="font-weight: normal">{{
                                                                                            invoice_data.delivery_address.country
                                                                                        }}</span> <br
                                                                                            v-if="invoice_data.delivery_address.country">
                                                                                    </p>
                                                                                </div>
                                                                            </td>

                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                            <td class="toptd bd-l-0">
                                                                <table id="in-tbl">
                                                                    <thead>
                                                                        <tr>
                                                                            <td colspan="2" class="headtd">
                                                                                <div>
                                                                                    <p class="sml">FREIGHT DETAILS:</p>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td class="bodytda">
                                                                                <div>
                                                                                    <p class="sml">
                                                                                        Net Weight (kg): {{
                                                                                            Number(invoice_data.net_weight).toFixed(2)
                                                                                        }}
                                                                                        Gross Weight (kg): {{
                                                                                            Number(invoice_data.gross_weight).toFixed(2)
                                                                                        }}<br>
                                                                                        No. of Boxes/Pallets: {{
                                                                                            invoice_data.no_of_pallets }}<br>
                                                                                        Dimensions: {{
                                                                                            invoice_data.dimensions }}<br>
                                                                                        Cube (m<sup>3</sup>): {{
                                                                                            invoice_data.cube }}<br>
                                                                                    </p>
                                                                                </div>
                                                                            </td>
                                                                            <td class="bodytdb">
                                                                                <!--                                <div>-->
                                                                                <!--                                  <p class="sml">Tel. 01635 261920<br>-->
                                                                                <!--                                    Email: sales@itstaste.com<br>-->
                                                                                <!--                                    VAT Reg No: 1234567890<br>-->
                                                                                <!--                                    Company No: 1234567890<br>-->
                                                                                <!--                                    EORI for NL: XI1234567890<br>-->
                                                                                <!--                                    EORI for EU: GB1234567890</p>-->
                                                                                <!--                                </div>-->
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr>

                                                            <td colspan="2" class="toptd">
                                                                <table id="content-tbl">
                                                                    <thead>
                                                                        <tr>
                                                                            <th><b>Customer Product Code</b></th>
                                                                            <th><b>Name/Product Code</b></th>
                                                                            <th><b>Work Order</b></th>
                                                                            <th><b>Quantity(KG)</b></th>
                                                                            <th><b>Pack Size (KG)</b></th>
                                                                            <th><b>Commodity Code</b></th>
                                                                            <th><b>Country of Origin</b></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(item, index) in invoice_data.order_items"
                                                                            :key="index">
                                                                            <td>{{ item.customer_product_code }}</td>
                                                                            <td>{{ item.product_name_code }}</td>
                                                                            <td>{{ item.work_orders }}</td>
                                                                            <td>{{ Number(item.quantity) }}</td>
                                                                            <td>{{ item.pack_size }}</td>
                                                                            <td>{{ item.commodity_code }}</td>
                                                                            <td>{{ item.origin }}</td>

                                                                        </tr>
                                                                        <tr>
                                                                            <td v-bind:style="styleObject" class="htd"
                                                                                rowspan="1">&nbsp;</td>
                                                                            <td v-bind:style="styleObject" class="htd"
                                                                                rowspan="1">&nbsp;</td>
                                                                            <td v-bind:style="styleObject" class="htd"
                                                                                rowspan="1">&nbsp;</td>
                                                                            <td v-bind:style="styleObject" class="htd"
                                                                                rowspan="1">&nbsp;</td>
                                                                            <td v-bind:style="styleObject" class="htd"
                                                                                rowspan="1">&nbsp;</td>
                                                                            <td v-bind:style="styleObject" class="htd"
                                                                                rowspan="1">&nbsp;</td>
                                                                        </tr>

                                                                    </tbody>
                                                                </table>
                                                            </td>

                                                        </tr>

                                                        <tr>
                                                            <td colspan="2" class="toptd">

                                                                <table class="no-bd-tbl">
                                                                    <thead>

                                                                        <tr>
                                                                            <td colspan="4">
                                                                                <b>Notes:</b> <br>
                                                                                <b>Special INSTRUCTIONS FOR DELIVERY: </b>{{
                                                                                    invoice_data.delivery_instruction }}
                                                                            </td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td colspan="2">
                                                                                <table>
                                                                                    <tr>
                                                                                        <td>
                                                                                            <p
                                                                                                style="font-weight: bolder; padding-top: 50px">
                                                                                                Transport by (company name):
                                                                                                ...............................<br>
                                                                                                <span class="pb-2">Driver's
                                                                                                    signature</span><br><br>
                                                                                                Print Name
                                                                                                ................................................................<br>
                                                                                                Date/Time of pick up
                                                                                                ................................................
                                                                                            </p>
                                                                                        </td>
                                                                                        <td>
                                                                                            <p
                                                                                                style="font-weight: bolder; padding-top: 50px">
                                                                                                <span class="mb-2">Consignee
                                                                                                    signature</span><br><br>
                                                                                                Print Name
                                                                                                .........................................................................<br>
                                                                                                Date/Time received
                                                                                                .................................................................
                                                                                            </p>
                                                                                        </td>
                                                                                    </tr>
                                                                                </table>
                                                                            </td>
                                                                            <td>
                                                                                <img v-if="!is_customer_uk"
                                                                                    style="padding-top: 25px" width="200"
                                                                                    src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/s_jones_signature.png"
                                                                                    alt="">
                                                                            </td>
                                                                            <td>
                                                                                <img v-if="!is_customer_uk"
                                                                                    style="padding-top: 25px" width="200"
                                                                                    src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/its_stamp.bmp"
                                                                                    alt="">
                                                                            </td>
                                                                        </tr>
                                                                    </thead>
                                                                </table>
                                                            </td>

                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>

                        </div>

                    </main>
                </div>
            </body>
        </page>
    </span>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
const CourierRepository = RepositoryFactory.get('courier')

import { Printd } from 'printd'

export default {
    name: 'DeliveryNote',
    data() {
        return {
            open: false,
            id: '',
            secret_code: '',
            is_full_screen: false,
            data: {},
            customer_email: "",
            activePrompt: false,
            invoice_data: {
                order_items: [],
                additional_costs: [],
                tel: '',
                shipper_address: {
                    company_name: '',
                    line_1: '',
                    line_2: '',
                    line_3: '',
                    town_state: '',
                    post_code: '',
                    country: '',
                },
                delivery_address: {
                    company_name: '',
                    line_1: '',
                    line_2: '',
                    line_3: '',
                    town_state: '',
                    post_code: '',
                    country: '',
                },
                customer_address: {
                    company_name: '',
                    line_1: '',
                    line_2: '',
                    line_3: '',
                    town_state: '',
                    post_code: '',
                    country: '',
                }
            },
            order_details: {
                supplier_address: {
                    name: '',
                    line1: '',
                    line2: '',
                    line3: '',
                    town_state: '',
                    post_code: '',
                    country: ''
                },
                deliver_to: {
                    name: '',
                    line1: '',
                    line2: '',
                    line3: '',
                    town_state: '',
                    post_code: '',
                    country: ''
                },
                invoice_to: {
                    name: '',
                    line1: '',
                    line2: '',
                    line3: '',
                    town_state: '',
                    post_code: '',
                    country: ''
                },
                order_date: '',
                order_number: '',
                items: [],
                delivery_instruction: '',
                generated_on: ''
            }
        }
    },
    computed: {
        styleObject: function () {
            const total_item_height = this.invoice_data.order_items.length * 55
            const space_height = 500 - total_item_height
            return {
                height: `${space_height}px`
            }
        },
        is_customer_uk: function () {
            return ['Great Britain', 'Northern Ireland', 'United Kingdom'].includes(this.invoice_data.customer_address.country);
        }
    },
    async mounted() {
        this.secret_code = this.$route.params.key
        this.is_full_screen = this.$route.query.is_full_screen === null
        await this.getInvoiceDetails()
    },
    methods: {
        itemNetValue() {
            const total = this.invoice_data.order_items.reduce((a, b) => a + Number(b.net_value) + Number(b.vat_value), 0)
            return Number(total).toFixed(2)
        },
        totalOrderValue() {
            const total_add_cost = this.invoice_data.additional_costs.reduce((a, b) => a + Number(b.amount), 0)
            const total = this.invoice_data.order_items.reduce((a, b) => a + Number(b.net_value) + Number(b.vat_value), 0)
            return Number(total_add_cost + total).toFixed(2)
        },
        async getInvoiceDetails() {
            await this.$vs.loading()
            try {
                const { data } = (await CourierRepository.getDeliveryNotePdfDataFromSecret(this.secret_code)).data
                this.invoice_data = data
            } catch (e) {
                this.showWarningMessage()
            }
            this.$vs.loading.close()
        },
        onClickPrint() {
            const d = new Printd()
            const styles = `
            html,
  body {
    -webkit-print-color-adjust: exact !important;
  }
  @media print {
    body {
      zoom: 100%;
    }
  }
  
  .clearfix:after {
    content: "";
    display: table;
    clear: both;
  }
  
  a {
    color: #0087C3;
    text-decoration: none;
  }
  
  body {
    position: relative;
    margin: 0 auto;
    color: #000000;
    background: #FFFFFF;
    font-family: Arial, sans-serif;
    font-size: 14px;
    line-height: 1.6;
  }
  
  div#full-wrap {
    width: 40cm;
    max-width: 100%;
    margin: 0 auto;
  }
  
  h4 {
    font-size: 24px;
  }
  
  p {
    font-size: 16px;
    margin: 0;
  }
  
  .sml {
    font-size: 13px;
  }
  
  main {
    padding: 0px 10px 20px 10px;
  }
  
  table {
    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 20px;
    font-size: 13px;
  
  }
  
  table th,
  table td {
    padding: 20px;
    text-align: center;
    vertical-align: top;
  }
  
  table td:nth-child(2) {
    word-break: break-all;
  }
  
  table th {
    white-space: nowrap;
    font-weight: normal;
    color: #000;
  }
  
  table td {
    text-align: left;
  }
  
  table.txt-center td {
    text-align: center;
  }
  
  table.txt-left td {
    text-align: left;
  }
  
  table.txt-right td {
    text-align: right;
  }
  
  
  div#user-top {
    width: 100%;
    margin: 2em auto 2em auto;
  }
  
  div#user-top table {
    margin: 0 auto 0 auto;
    text-align: center;
    width: 100%;
  }
  
  div#user-top table td {
    padding: 5px 20px;
    font-size: 14px;
  }
  
  div#user-top .head {
    vertical-align: middle;
    text-align: center;
  
  }
  
  table#in-tbl {
    width: 100%;
  
  }
  
  table#in-tbl td {
    border: 2px solid #000;
  
  }
  
  table#in-tbl thead td.headtd {
    border: 2px solid #000;
    border-bottom-width: 0px;
  
  }
  
  table#in-tbl tbody td.bodytda {
    border: 2px solid #000;
    border-top-width: 0px;
    border-right-width: 0px;
  
  }
  
  table#in-tbl tbody td.bodytdb {
    border: 2px solid #000;
    border-top-width: 0px;
    border-left-width: 0px;
  
  }
  
  table#in-tbl tbody td.bodytd {
    border: 2px solid #000;
    border-top-width: 0px;
  
  
  }
  
  table#main-tbl thead td {
    border: 3px solid #000;
    border-bottom-width: 2px;
  
  }
  
  table#main-tbl tbody td.toptd {
    border: 3px solid #000;
    border-top-width: 0px;
    padding: 5px;
    width: 50%;
  }
  
  table#main-tbl tbody td.toptd table#in-tbl {
    min-height: 15em;
  }
  
  table#content-tbl th,
  table#content-tbl td {
    border: 2px solid #000;
    font-size: 13px !important;
    text-align: center;
  }
  
  
  /* table#content-tbl td[rowspan="1"] {
      height: 300px;
  } */
  
  
  td.no-bd {
    border-left: 0px !important;
    border-bottom: 0px !important;
  }
  
  table.no-bd-tbl td {
    border: 0px !important;
  
  }
  
  table.no-bd-tbl {
    margin-bottom: 0 !important;
  }
  
  .align-left {
    text-align: left !important;
  }
  
  .align-center {
    text-align: center !important;
  }
  
  .align-right {
    text-align: right !important;
  }
  
  footer {
    padding: 0 30px;
  }
  
  .p-0 {
    padding: 0 !important;
  }
  
  .m-0 {
    margin: 0 !important;
  }
  
  .bd-b-0 {
    border-bottom-width: 0px !important;
  }
  
  .bd-r-0 {
    border-right-width: 0px !important;
  }
  
  .bd-l-0 {
    border-left-width: 0px !important;
  }
          `
            d.print(document.getElementById('myelement'), [styles])
        },
        totalCalculator() {
            let total = 0;
            this.order_details.items.forEach((m) => {
                if (!!m.price) {
                    total = total + Number(m.value)
                }
            })
            return total.toFixed(2)
        },
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style lang="scss">
html,
body {
    -webkit-print-color-adjust: exact !important;
}

page {
    background: white;
    display: block;
    margin: 0 auto;
    margin-bottom: 0.5cm;
    box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

page[size="A4"] {
    width: 30cm;
    height: auto;
}

@media print {
    .print-view {
        * {
            visibility: hidden;
        }

        #content-area {
            margin: 0 !important;
        }

        #printDiv,
        #printDiv * {
            visibility: visible;
        }

        #printDiv {
            position: absolute;
            left: 0;
            top: 0;
            box-shadow: none;
        }
    }
}

/*@media print {*/
/*  body {*/
/*    zoom: 50%;*/
/*  }*/
/*}*/

.clearfix:after {
    content: "";
    display: table;
    clear: both;
}

a {
    color: #0087C3;
    text-decoration: none;
}

body {
    position: relative;
    margin: 0 auto;
    color: #000000;
    background: #FFFFFF;
    font-family: Arial, sans-serif;
    font-size: 14px;
    line-height: 1.6;
}

div#full-wrap {
    width: 40cm;
    max-width: 100%;
    margin: 0 auto;
}

h4 {
    font-size: 24px;
}

p {
    font-size: 16px;
    margin: 0;
}

.sml {
    font-size: 13px;
}

main {
    padding: 0px 10px 20px 10px;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 20px;
    font-size: 13px;

}

table th,
table td {
    padding: 20px;
    text-align: center;
    vertical-align: top;
}

table td:nth-child(2) {
    word-break: break-all;
}

table th {
    white-space: nowrap;
    font-weight: normal;
    color: #000;
}

table td {
    text-align: left;
}

table.txt-center td {
    text-align: center;
}

table.txt-left td {
    text-align: left;
}

table.txt-right td {
    text-align: right;
}


div#user-top {
    width: 100%;
    margin: 2em auto 2em auto;
}

div#user-top table {
    margin: 0 auto 0 auto;
    text-align: center;
    width: 100%;
}

div#user-top table td {
    padding: 5px 20px;
    font-size: 14px;
}

div#user-top .head {
    vertical-align: middle;
    text-align: center;

}

table#in-tbl {
    width: 100%;

}

table#in-tbl td {
    border: 2px solid #000;

}

table#in-tbl thead td.headtd {
    border: 2px solid #000;
    border-bottom-width: 0px;

}

table#in-tbl tbody td.bodytda {
    border: 2px solid #000;
    border-top-width: 0px;
    border-right-width: 0px;

}

table#in-tbl tbody td.bodytdb {
    border: 2px solid #000;
    border-top-width: 0px;
    border-left-width: 0px;

}

table#in-tbl tbody td.bodytd {
    border: 2px solid #000;
    border-top-width: 0px;


}

table#main-tbl thead td {
    border: 3px solid #000;
    border-bottom-width: 2px;

}

table#main-tbl tbody td.toptd {
    border: 3px solid #000;
    border-top-width: 0px;
    padding: 5px;
    width: 50%;
}

table#main-tbl tbody td.toptd table#in-tbl {
    min-height: 15em;
}

table#content-tbl th,
table#content-tbl td {
    border: 2px solid #000;
    font-size: 13px !important;
    text-align: center;
}


/* table#content-tbl td[rowspan="1"] {
      height: 300px;
  } */


table#content-tbl td.htd {
    height: 800px;
}

td.no-bd {
    border-left: 0px !important;
    border-bottom: 0px !important;
}

table.no-bd-tbl td {
    border: 0px !important;

}

table.no-bd-tbl {
    margin-bottom: 0 !important;
}

.align-left {
    text-align: left !important;
}

.align-center {
    text-align: center !important;
}

.align-right {
    text-align: right !important;
}

footer {
    padding: 0 30px;
}

.p-0 {
    padding: 0 !important;
}

.m-0 {
    margin: 0 !important;
}

.bd-b-0 {
    border-bottom-width: 0px !important;
}

.bd-r-0 {
    border-right-width: 0px !important;
}

.bd-l-0 {
    border-left-width: 0px !important;
}
</style>
  